import styles from './BlockTextAreaGray.module.scss';

import type { FC, ReactNode } from 'react';

export type Props = {
  title?: string;
  children: ReactNode;
};

export const BlockTextAreaGray: FC<Props> = ({ children, title }) => (
  <div className={styles.wrap}>
    {title ? <span className={styles['wrap-title']}>{title}</span> : ''}
    <span className={styles['wrap-text']}>{children}</span>
  </div>
);
